import { set } from 'lodash';
import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        profile:{
            id: "",
            nick: "",
        },
        diagnosis: {}, // 分类以及体质特征
        selectKey: ""
    },
    mutations: {
        /**
         * 设置profile的值
         */
        setProfile(state, profile) {
            state.profile = profile;
        },
        /**
         * 设置问卷KEY
         */
        setKey(state, key) {
            state.selectKey = key;
        },
        /**
         * 
         */
        setDiagnosis(state, diagnosis) {
            state.diagnosis = diagnosis;
        }
    },
    actions: {

    },
    modules: {
    }
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js